/**
 * @generated SignedSource<<dc18591c06566421a31985e1997234e7>>
 * @relayHash 2d25988a99ccf3cb7f148576013eb15f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9f862449f05f03d050cb713bb981af544d0403aff0ea69b00762a41d6e9c89c2

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraIssueArchiveInput = {
  ids: ReadonlyArray<string>;
};
export type deleteIssueView_ArchiveIssueMutation$variables = {
  input: JiraIssueArchiveInput;
};
export type deleteIssueView_ArchiveIssueMutation$data = {
  readonly jira_archiveIssue: {
    readonly errors: ReadonlyArray<{
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type deleteIssueView_ArchiveIssueMutation = {
  response: deleteIssueView_ArchiveIssueMutation$data;
  variables: deleteIssueView_ArchiveIssueMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "JiraIssueArchivePayload",
    "kind": "LinkedField",
    "name": "jira_archiveIssue",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "deleteIssueView_ArchiveIssueMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteIssueView_ArchiveIssueMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "9f862449f05f03d050cb713bb981af544d0403aff0ea69b00762a41d6e9c89c2",
    "metadata": {},
    "name": "deleteIssueView_ArchiveIssueMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "eb25f7061b0d8c61387a7905e70e6d53";

export default node;
